<template>
  <AvatarFallback 
    :class="cn('flex h-full w-full items-center justify-center rounded-full bg-muted', props.class)"
    v-bind="$attrs"
  >
    <slot />
  </AvatarFallback>
</template>

<script setup>
import { AvatarFallback } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  class: String
})
</script>